/**
 * StaggeredList Component
 * Renders children with staggered delay for cascading animation effect
 */

import React from 'react';
import clsx from 'clsx';
import './animations.css';

export type StaggerAnimation = 'fadeIn' | 'slideUp' | 'scaleIn';

export interface StaggeredListProps {
  children: React.ReactNode[];
  staggerDelay?: number; // in milliseconds
  animation?: StaggerAnimation;
  className?: string;
}

export const StaggeredList: React.FC<StaggeredListProps> = ({
  children,
  staggerDelay = 100,
  animation = 'fadeIn',
  className,
}) => {
  const animationClass = `ai360-animate-${animation}`;

  return (
    <>
      {React.Children.map(children, (child, index) => {
        if (!child) return null;
        
        const delay = (index * staggerDelay) / 1000; // Convert to seconds

        return (
          <div
            className={clsx(animationClass, className)}
            style={{
              '--delay': `${delay}s`,
            }}
          >
            {child}
          </div>
        );
      })}
    </>
  );
};
